import React from 'react';
import './StatHeaderWidget.css';

const StatHeaderWidget = ({
    isAttribute = false,
    isPrimary = false,
    isTopHeader = false,
    categoryName = "",
    characterPoints,
    simpleMode = false,
}) => {
    const labelClassName = `stat-header label${isAttribute || simpleMode ? '' : ' span-2'}`;

    return (
        <>
            <h6 className={labelClassName}>{categoryName}</h6>

            {isAttribute && (
                <div className='attribute-header'>
                    <h6 className='stat-header base'>{characterPoints}</h6>
                    {/* <span className='stat-header scroll'>{ }</span> */}
                </div>
            )}

            <span className={`stat-header${isPrimary ? '' : ' blank'}`} aria-hidden="true" />

            {!simpleMode && (
                <span className={`stat-header${isTopHeader ? ' target' : ' blank'}`} aria-hidden="true" />
            )}
        </>
    );
};

export default StatHeaderWidget;
